import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "date"
}
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "price" }

import { PropType } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { Game } from '@/models/game.model';
import { formatDate, formatPrice } from '@/core/filters';


export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseItem',
  props: {
  purchase: {
    type: Object as PropType<any>,
    required: true,
  },
  links: {
    type: Boolean,
    required: false,
    default: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();
const router = useRouter();



const showItem = (evt: Event) => {
  store.commit('setViewItem', props.purchase);
  if ((props.purchase as Game).IS_GAME) {
    router.push('/game/' + props.purchase.url);
  } else {
    router.push(`/hardware/purchase/${props.purchase.url}/edit`);
  }
  evt.preventDefault();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("span", {
      class: _normalizeClass('icon icon-' + __props.purchase.icon),
      title: __props.purchase.store
    }, null, 10, _hoisted_1),
    (__props.purchase.date)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(formatDate)(__props.purchase.date)), 1))
      : _createCommentVNode("", true),
    (__props.links)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: "#",
          class: "name",
          textContent: _toDisplayString(__props.purchase.name),
          onClick: showItem
        }, null, 8, _hoisted_3))
      : (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "name",
          textContent: _toDisplayString(__props.purchase.name)
        }, null, 8, _hoisted_4)),
    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatPrice)(__props.purchase.price)), 1)
  ]))
}
}

})